import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { AtiraImage } from "../../../../../components/Image";
import { ConversationMessage } from "../../../../../model/integration/dto/meta/MetaConversationMessage";
import { getMediaUrl } from "../../../../../utils/Media";
import { WAMediaRetentionInfo } from "./WAMediaRetentionInfo";
import { WAMediaUnavailable } from "./WAMediaUnavailable";
import { isMediaPending } from "./media-state";

/** Stickers are square and want no frame or background of their own. */
const Sticker = styled(AtiraImage)`
  width: 8rem;
  height: 8rem;
  object-fit: contain;
`;

const Media = styled.div`
  position: relative;
  width: fit-content;
`;

type Props = {
  message: ConversationMessage;
};

export const WAMessageSticker: React.FC<Props> = ({ message }) => {
  const { mediaId, localPreviewUrl } = message;
  const { t } = useTranslation();

  if (!mediaId && !localPreviewUrl) {
    return (
      <WAMediaUnavailable
        label={t("common.whatsapp.sticker")}
        expired={Boolean(message.mediaExpiredAt)}
        pending={isMediaPending(message)}
      />
    );
  }

  return (
    <Media>
      <Sticker
        src={localPreviewUrl || getMediaUrl(mediaId!)}
        alt={t("common.whatsapp.sticker")}
      />

      {mediaId ? <WAMediaRetentionInfo createdAt={message.createdAt} /> : null}
    </Media>
  );
};
